import { render, staticRenderFns } from "./ChatContentHeader.vue?vue&type=template&id=60b0c37a&scoped=true"
import script from "./ChatContentHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatContentHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ChatContentHeader.vue?vue&type=style&index=0&id=60b0c37a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b0c37a",
  null
  
)

export default component.exports